// removed by extract-text-webpack-plugin
module.exports = {"chat":"VbTsuUx0PAiE6mb0gQYwJ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Chat/Chat.scss
// module id = 1061
// module chunks = 0